import { render, staticRenderFns } from "./FinalizacaoConfirmApproveDialog.vue?vue&type=template&id=73850dd9"
import script from "./FinalizacaoConfirmApproveDialog.vue?vue&type=script&lang=js"
export * from "./FinalizacaoConfirmApproveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports